module.exports = __webpack_public_path__ + "img/scene-factory.efce83ac.jpg";